import Vue from 'vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from '@/plugins/router';
import vuetify from '@/plugins/vuetify';
import dotenv from 'dotenv';
import store from '@/store/store';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

import '@/components';
import '@/components/common/wrappers';
import '@/components/pages/CreateStudyPage';
import '@/components/pages/StudyHomePage';
import '@/components/pages/LoginPage';
import '@/components/pages/LoginSsoPage';
import '@/components/pages/ReportBugPage';
import '@/components/pages/LandingPage';
import '@/components/pages/RespondentsWizardPage';
import '@/components/pages/RegistrationPage';
import '@/components/pages/ProfilePage';
import '@/components/pages/ChangePasswordPage';
import '@/components/pages/TestPage';
import '@/components/pages/WhatsNewPage';
import '@/components/pages/AdminHomePage';
import '@/components/pages/AdminHomePage/users';
import '@/components/pages/AdminHomePage/studies';
import '@/components/pages/AdminHomePage/messages';
import '@/components/pages/InstructionsPage';

// Importing the global css file
import '@/assets/global.css';

// Importing the component configs to be access globally
import Configs from '@/plugins/configs';
// Import the text lists to be accessed globally
import GlobalText from '@/plugins/globalText';

dotenv.config()
Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(VueMeta);
Vue.use(Configs);
Vue.use(GlobalText);

new Vue({
	router,
	vuetify,
	store,
	render: h => h(App)
}).$mount('#app');
